import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const getMemberships = async (state: IStore, clubId: string | number, force?: boolean) => {
  if (
    state.adminMemberships &&
    state.adminMemberships.memberships &&
    state.adminMemberships.memberships.length > 0 &&
    !force
  ) {
    return state;
  }

  const response = await request.get(`${api.admin.clubs}${clubId}/memberships/`);

  if (response.error) {
    return { errors: { memberships: { msg: 'Error retrieving club memberships.' } } };
  }

  return {
    adminMemberships: {
      memberships: response
    }
  };
};
